
import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router-dom';
import {
  Button,
  Container,
  Segment,
  Header,
  Responsive
} from 'semantic-ui-react';

import AppContainer from './AppContainer';

/* eslint-disable react/no-multi-comp */
/* Heads up! HomepageHeading uses inline styling, however it's not the best practice. Use CSS or styled components for
 * such things.
 */
const Homehead = ({ mobile }) => (
  <Segment
    textAlign='center'
    style={{ minHeight: 700, padding: '1em 0em' }}
    vertical
    id="homepageHeading"
  >
    <Container text>
      <Header
        as='h1'
        content='Capture Your Dream'
        inverted
        style={{
          fontSize: mobile ? '2em' : '4em',
          fontWeight: 'normal',
          marginBottom: '2em',
          marginTop: '10px',
        }}
      />
      <Link to='/new/'>
        <Button primary size='huge'>
          Make a Book Now
        </Button>
      </Link>
    </Container>
  </Segment>
);

Homehead.propTypes = {
  mobile: PropTypes.bool,
};

const HomepageLayout = () => (
  <AppContainer>
    <Responsive minWidth={Responsive.onlyTablet.minWidth}>
      <Homehead />
    </Responsive>
    <Responsive maxWidth={Responsive.onlyMobile.maxWidth}>
      <Homehead mobile />
    </Responsive>
  </AppContainer>
);

export default HomepageLayout;
